module.exports = __webpack_public_path__ + "img/surakshitha_product_img.ed5c6c60.jpg";